import styled from 'styled-components';
import { media } from '../../../../Utils/mediaQueries';

export const ClassRowContainer = styled.div`
    width: 100%;
    min-height: 80px;
    margin: 15px 0;

    display: flex;
    align-items: center;
`;

export const ClassRowWrapper = styled.div`
    width: 100%;
`;

export const ClassDateRow = styled.div`
    width: 100%;
    margin: 20px 0 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ClassRowTime = styled.div`
    width: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ClassRowImage = styled.div`
    width: 106px;
    height: 80px;

    border-radius: 8px;

    background-image: ${props => (props.image ? `url(${props.image})` : '')};
    background-size: cover;
`;

export const ClassRowData = styled.div`
    padding: 2px 0;
    margin-left: 20px;
    min-height: 80px;

    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const ClassRowOptions = styled.div`
    display: flex;
    min-height: 80px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
`;

export const MiddleDataRow = styled.div`
    display: flex;
    align-items: center;
`;

export const TinyAvatar = styled.div`
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.31);
    border-radius: 100px;
    background-image: ${props => (props.image ? `url(${props.image})` : '')};
    background-size: cover;
`;

export const BottomDataRow = styled.div`
    display: flex;

    & div:first-child {
        margin-right: 20px;
    }

    & div:last-child {
        margin-left: 20px;
    }
`;

export const BottomDataItem = styled.div`
    display: flex;
    align-items: center;
`;

export const EditButton = styled.button`
    width: 91px;
    height: 30px;
    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    border-radius: 100px;
    outline: none;
    cursor: pointer;
`;

export const CardContainer = styled.div`
    width: 100%;
    display: none;

    ${media.phone`
        display: block;
    `};
`;

export const ClassCard = styled.div`
    width: 100%;
    height: 200px;
    background-image: ${props => (props.image ? `url(${props.image})` : '#000')};
    opacity: ${props => (props.isSelected ? '1' : '0.7')};
    background-size: cover;
    display: block;
    position: relative;
    margin-bottom: 15px;

    border-radius: 10px;
`;

export const ClassCardContent = styled.div`
    width: 100%;
    height: 100%;
    padding: 10px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const DarkOverlay = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 10px;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 0;
`;

export const DarkButton = styled(EditButton)`
    height: 23px;
    color: white;
    font-size: 12px;
    text-transform: uppercase;
    transition: all 0.2s ease;

    &:hover {
        opacity: 0.75;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/ClassRow/style.js